export enum ModalRoutes {
  Home = "home",
  Roles = "roles",
  Permissions = "permissions",
}
